import React from 'react';
import { GAN_WX, ZHI_WX } from './tables.js';
import { SHI_SHEN_MEANING, PLAIN_SHI_SHEN } from './meanings.js';

const WX_COLOR = { 木: '#2e7d32', 火: '#c62828', 土: '#9c6b3f', 金: '#607d8b', 水: '#1565c0' };

export default function PillarCard({ p, isDay, active, onSelect }) {
  return (
    <div className={`bz-pillar ${isDay ? 'bz-day' : ''} ${active ? 'active' : ''}`}
      role="button" tabIndex={0}
      onClick={() => onSelect && onSelect(p)}
      onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onSelect && onSelect(p)}
      title="点击展开此柱详解">
      <div className="bz-label">{p.label}{isDay && <i className="bz-daytag">日主</i>}<span className="bz-caret">{active ? '▴' : '▾'}</span></div>
      <div className="bz-gan" style={{ color: WX_COLOR[GAN_WX[p.gan]] }}
        title={`${p.gan}（${GAN_WX[p.gan]}）｜十神：${p.ssGan}\n白话：${PLAIN_SHI_SHEN[p.ssGan] || ''}\n${SHI_SHEN_MEANING[p.ssGan] || ''}`}>
        {p.gan}
      </div>
      <div className="bz-ssgan" title={SHI_SHEN_MEANING[p.ssGan] || ''}>{p.ssGan}</div>
      <div className="bz-zhi" style={{ color: WX_COLOR[ZHI_WX[p.zhi]] }}
        title={`${p.zhi}（${ZHI_WX[p.zhi]}）｜地支十二长生（以日主论）：${p.csZhi}`}>
        {p.zhi}
      </div>
      <div className="bz-hide">
        {p.hide.map((h, i) => (
          <span key={i} className="bz-hide-item"
            title={`藏干 ${h}（${GAN_WX[h]}）｜${p.zhi}中藏：${p.hide.join('、')}｜此字十神：${p.ssZhi[i]}`}>
            {h}<small>{p.ssZhi[i]}</small>
          </span>
        ))}
      </div>
      <div className="bz-nayin" title={`纳音五行（六十甲子配三十纳音，古法）`}>{p.naYin}</div>
      <div className="bz-cs" title="地支十二长生（以日主为基准：长生沐浴冠带临官帝旺衰病死墓绝胎养）">{p.csZhi}</div>
    </div>
  );
}
